import { render } from "./AgendamentoView.vue?vue&type=template&id=5bd1d1b4&ts=true"
import script from "./AgendamentoView.vue?vue&type=script&lang=ts"
export * from "./AgendamentoView.vue?vue&type=script&lang=ts"

import "./AgendamentoView.vue?vue&type=style&index=0&id=5bd1d1b4&lang=css"

import exportComponent from "/codebuild/output/src1991399693/src/agendamento-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__